import { Routes } from '@angular/router';

import { documentSegments } from '@advania-cosoftware/wolf-router';

export const documentsRoutes: Routes = [
    {
        path: documentSegments.wikiArticles,
        loadComponent: () => import('./pages/wiki-articles/wiki-articles.page').then((m) => m.WikiArticlesPage),
    },
    {
        path: `${documentSegments.wikiArticles}/:wikiRevisionId`,
        loadComponent: () => import('./pages/wiki-article/wiki-article.page').then((m) => m.WikiArticlePage),
    },
    {
        path: documentSegments.releaseNotes,
        loadComponent: () => import('./pages/release-notes/release-notes.page').then((m) => m.ReleaseNotesPage),
    },
];
